export enum LocalStorage {
	ACCESS_TOKEN = 'access_token',
	REFRESH_TOKEN = 'refresh_token',
	PROFILE = 'user_profile',
	LAST_ROUTE = 'last_route'
}
